/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Chip } from '@material-ui/core'
import StatusIcon from '../StatusIcon'

const orange_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#FF6701",
        contrastText : "#FFFFFF"
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({})

class OperationChip extends Component {
    state = {  }

    getOpAnnotaion = () => {
        let op_annot = this.props.ic.operationAnnotations.find(op => op.type === this.props.op).annotation
        return op_annot
    }

    getTrainingStatus = () => {
        // console.log("Status Operation: ", this.props.op)
        let status_objs = this.props.ic.training_status_object.filter(status => status.operation === this.props.op)
        console.log("Status Operation Objects: " + this.props.ic.name, status_objs)

        let sorted_status = status_objs.sort((a,b) => new Date(b.request_time).getTime() - new Date(a.request_time).getTime())
        console.log("Sorted Status : " + this.props.ic.name, sorted_status)
        let last_status = sorted_status.length > 0 ? sorted_status[0].status : null
        // let last_status = status_objs.length > 0 ? status_objs[status_objs.length - 1].status : null
        console.log("Status Operation Last State: " + this.props.ic.name, last_status)
        return last_status
    }

    render() { 
        return (
            <ThemeProvider theme = {orange_theme}>
                <Chip
                    style = {{margin : '3px'}}
                    variant = 'outlined'
                    color = 'primary'
                    label = {this.getOpAnnotaion()}
                    icon = {<StatusIcon style = {{marginLeft : '3px'}} status = {this.getTrainingStatus()} status_clicked = {() => null} prefix = {this.props.ic.name} in_progress = "refresh_circle"/>}
                />
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(OperationChip);